import { Form, Radio, RadioChangeEvent } from 'antd'
import { FC } from 'react'
import { requiredRules } from '../../../../../constants/forms/validation/rules'

interface ShapeProps {
    onChange: (e: RadioChangeEvent) => void
}

const Shape: FC<ShapeProps> = ({ onChange }) => {
    return (
        <Form.Item name={'shape'} label={'Форма'} rules={requiredRules}>
            <Radio.Group
                style={{ display: 'flex', flexDirection: 'column' }}
                options={[
                    { value: undefined, label: 'Любая' },
                    { value: 'Квадрат', label: 'Квадрат' },
                    { value: 'Круг', label: 'Круг' },
                    { value: 'Овал', label: 'Овал' },
                    { value: 'Прямоугольный', label: 'Прямоугольный' },
                    { value: 'Фигурный', label: 'Фигурный' },
                ]}
                onChange={onChange}
            />
        </Form.Item>
    )
}

export default Shape
